import { render, staticRenderFns } from "./PermissionSetting.vue?vue&type=template&id=b1ad758a"
import script from "./PermissionSetting.vue?vue&type=script&lang=js"
export * from "./PermissionSetting.vue?vue&type=script&lang=js"
import style0 from "./PermissionSetting.vue?vue&type=style&index=0&id=b1ad758a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports